module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e851430"
    }
  }, [_c('b', [_vm._v("ROASTED EGGPLANT DIP WITH HERBS")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e852230"
    }
  }, [_c('b', [_c('i', [_vm._v("The fresh flavors of lemon and mint are a perfect match for the baked eggplant in this Mediterranean-style dip.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e853230"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes plus cooling and draining Roast: 1 hour")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e854130"
    }
  }, [_vm._v("2 small eggplants (1 pound each)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e854430"
    }
  }, [_vm._v("2 garlic cloves, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e854730"
    }
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e855030"
    }
  }, [_vm._v("4 teaspoons fresh lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e855330"
    }
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e855630"
    }
  }, [_vm._v("¼ teaspoon ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e856630"
    }
  }, [_vm._v("2 tablespoons chopped fresh parsley")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e856930"
    }
  }, [_vm._v("2 tablespoons chopped fresh mint "), _c('br'), _vm._v(" toasted pita bread wedges")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e857730"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Preheat oven to 400°F. With knife, cut slits all over eggplants; insert garlic slices in slits. Place eggplants in jelly-roll pan and roast until collapsed and tender, about 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0030_002",
      "src": "Images/9781618371621_0030_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e860930"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" When cool enough to handle, cut eggplants in half. Scoop out flesh and place in colander set over bowl; discard skin. Let drain 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e863430"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Transfer eggplant to food processor with knife blade attached. Add oil, lemon juice, salt, and pepper; pulse to coarsely chop. Add parsley and mint, pulsing to combine. Spoon into bowl; cover and refrigerate up to 4 hours. Serve with toasted pita bread wedges. Makes about 2 cups.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e866230"
    }
  }, [_vm._v("Each tablespoon: About 14 calories, 0g protein, 2g carbohydrate, 1g total fat (0g saturated), 0mg cholesterol, 74mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e867230"
    }
  }, [_c('b', [_vm._v("BABA GANOUSH")])]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d7e867730"
    }
  }, [_vm._v("Prepare as directed above. Omit parsley and mint. Stir in "), _c('b', [_vm._v("½ teaspoon ground cumin, ¼ cup tahini (sesame seed paste), ")]), _vm._v("and "), _c('b', [_vm._v("½ cup low-fat plain yogurt.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7b2303e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c11_r1.vue
// module id = 99
// module chunks = 0